/**
 * Color mapping for arbitrary, agent-provided order/shipment status strings
 * (as opposed to the WISMO order_insight payload's fixed health/severity
 * enums, which have their own design-doc-defined color mapping). Comparison
 * is case-insensitive since the raw OM-WISMO tool responses aren't a
 * UI-defined contract and casing isn't guaranteed.
 */
const BLUE_STATUSES = new Set(['OPEN', 'RELEASED']);
const RED_STATUSES = new Set(['FAILED_TO_VALIDATE', 'FAILED_TO_ALLOCATE', 'CANCELED']);
const GREEN_STATUSES = new Set(['SHIPPED', 'INVOICED', 'CLOSED']);

export interface StatusChipColor {
  backgroundColor: string;
  textColor: string;
}

export function getStatusChipColor(status: string | undefined): StatusChipColor {
  const normalized = (status ?? '').trim().toUpperCase();

  if (BLUE_STATUSES.has(normalized)) {
    return { backgroundColor: 'var(--chat-info-subtle)', textColor: 'var(--chat-info)' };
  }
  if (RED_STATUSES.has(normalized)) {
    return { backgroundColor: 'var(--chat-error-subtle)', textColor: 'var(--chat-error)' };
  }
  if (GREEN_STATUSES.has(normalized)) {
    return { backgroundColor: 'var(--chat-success-subtle)', textColor: 'var(--chat-success)' };
  }
  // All other statuses — yellow.
  return { backgroundColor: 'var(--chat-warning-subtle)', textColor: 'var(--chat-warning)' };
}
